module.exports = __webpack_public_path__ + "img/bus_blue_1.dfb585d6.svg";